// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'int',
  apiUrl: 'https://c9zc8wdj20.execute-api.eu-west-1.amazonaws.com',
  apiEnv: '/pro',
  appId: '13dc7f41-cd0f-4aba-a844-8858edeb4db0',
  tenantId: '93ad25dd-8cdc-4066-9727-31a8a3024f80',
  oktaAuthority: 'https://login.maresel.mre.pre.aws.mapfre.com/oauth2/default',
  oktaScope: 'openid profile',
  oktaClientId: '0oawsynvho1BTO21u417',
  oktaSettingsUrl: 'https://login.maresel.mre.pre.aws.mapfre.com/account-settings/security',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};


// export const environment = {
//   production: false,
//   environmentName: 'int',
//   apiUrl: 'http://127.0.0.1:3000',
//   apiEnv: '',
//   appId: '13dc7f41-cd0f-4aba-a844-8858edeb4db0',
//   tenantId: '93ad25dd-8cdc-4066-9727-31a8a3024f80',
//   oktaAuthority: 'https://login.maresel.mre.pre.aws.mapfre.com/oauth2/default',
//   oktaScope: 'openid profile',
//   oktaClientId: '0oawsynvho1BTO21u417',
//   oktaSettingsUrl: 'https://login.maresel.mre.pre.aws.mapfre.com/account-settings/security',
//   firebaseConfig: {
//     apiKey: '',
//     authDomain: '',
//     databaseURL: '',
//     projectId: '',
//     storageBucket: '',
//     messagingSenderId: '',
//     appId: '',
//     measurementId: ''
//   }
// };


/*
 * URL a la API
 *  Pre : https://0wb3hxpryb.execute-api.eu-west-1.amazonaws.com
 *  Int : https://c9zc8wdj20.execute-api.eu-west-1.amazonaws.com
 *  PRO: https://d19i1tk0wlxbrm.cloudfront.net
 *
 *  AppId
 *  Pre: 5661ea41-1289-4491-b220-cb82871e23ef
 *  Int: 3d8799a2-fa35-4c9a-bca5-67c6ec4eacdc
 *  tenantId: 5cc6c66d-ffb2-469f-9385-cda840e57836
 *
 */

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
